import {
    integrationClientFlags,
    integrationClientFlagsEnum,
    internalEntityTypes,
    internalEntityTypesEnum,
} from "helpers/enums";

export type IntegrationClientFlagName = (typeof integrationClientFlagsEnum)[keyof typeof integrationClientFlagsEnum];

export const noIntegrationClientFlags = 0;

export const queuedApiTaskModelTypesEnum = {
    Default: "Default",
    BidSharedInfoForForwardingModel: "BidSharedInfoForForwardingModel",
    Summary: "Summary",
} as const;
export type QueuedApiTaskModelType = (typeof queuedApiTaskModelTypesEnum)[keyof typeof queuedApiTaskModelTypesEnum];
export const integrationSubscriptionModelTypes = [
    { label: "Краткие", value: queuedApiTaskModelTypesEnum.Summary },
    { label: "Полные", value: queuedApiTaskModelTypesEnum.Default },
];

/** IntegrationBidQueuedApiTaskReadHandler is the only reader that accepts ExternalIntegration. */
export const integrationSubscriptionEntityTypes = internalEntityTypes.filter(
    ({ value }) => value === internalEntityTypesEnum.Bid,
);

/** JSON enum names represent known flags; unnamed combinations are serialized as a number. */
export const integrationClientFlagsMask = (flags: number | IntegrationClientFlagName): number => {
    if (typeof flags === "number") {
        return flags;
    }
    // The backend serializes None even though it has no display label in the generated enum.
    if (flags === "None") {
        return noIntegrationClientFlags;
    }
    const flag = integrationClientFlags.find((item) => item.value === flags);
    if (!flag) {
        throw new Error(`Unsupported integration client flags: ${flags}`);
    }
    return flag.intValue;
};
